export default __webpack_public_path__ + "54c9212c825f151c5fd7739cba401ff7.jpg";